import { useMemo } from "react";
import styles from "./CompanyLinkedInStyleColourIcon.module.css";

const CompanyLinkedInStyleColourIcon = ({
  dimensionLabel,
  companyLinkedInStyleColouWidth,
  companyLinkedInStyleColouHeight,
  companyLinkedInStyleColouPosition,
  companyLinkedInStyleColouFlexShrink,
}) => {
  const companyLinkedInStyleColourIconStyle = useMemo(() => {
    return {
      width: companyLinkedInStyleColouWidth,
      height: companyLinkedInStyleColouHeight,
      position: companyLinkedInStyleColouPosition,
      flexShrink: companyLinkedInStyleColouFlexShrink,
    };
  }, [
    companyLinkedInStyleColouWidth,
    companyLinkedInStyleColouHeight,
    companyLinkedInStyleColouPosition,
    companyLinkedInStyleColouFlexShrink,
  ]);

  return (
    <img
      className={styles.companylinkedinStylecolourIcon}
      alt=""
      src={dimensionLabel}
      style={companyLinkedInStyleColourIconStyle}
    />
  );
};

export default CompanyLinkedInStyleColourIcon;
